import React, { useState, useEffect } from "react";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import swal from "sweetalert";
import {  Spinner } from "react-bootstrap";
import Switch from "react-switch";
function PaymentOption() {
  const [options, setOptions] = useState("");
  const [paymentId, setPaymentId] = useState("");
  const [spinner, setSpinner] = useState(true);
  function getPaymentOptions() {
    let opt = [];
    axios
      .get(Baseurl.baseurl + "/go-ui/get-payment-mode-front")
      .then((response) => {
        if (response.data.status) {
          console.log("paymetnt", response.data.paymentMode);
          setPaymentId(response.data.paymentMode[0]._id)
          opt.push(
            {
              name: "CashFree",
              status: response.data.paymentMode[0].CashFree,
            },
            {
              name: "Inai",
              status: response.data.paymentMode[0].Inai,
            },
            {
              name: "JustPay",
              status: response.data.paymentMode[0].JustPay,
            },
            {
              name: "Paytm",
              status: response.data.paymentMode[0].Paytm,
            },
            {
              name: "RazorPay",
              status: response.data.paymentMode[0].RazorPay,
            }
          );
        }
        setOptions(opt);
        setSpinner(false);
      });
  }
  useEffect(() => {
    getPaymentOptions();
  }, []);

  function changePaymentOption(name,status) {
    if(!status){
      const artical = {
        razorPay:name==='RazorPay'?!status:status,
        paytm:name==='Paytm'?!status:status,
        justpay:name==='JustPay'?!status:status,
        cashFree:name==='CashFree'?!status:status,
        inai:name==='Inai'?!status:status
      };
  console.log('dats body',artical)
      axios
        .put(`${Baseurl.baseurl}/go-ui/update-payment-mode-front/${paymentId}`, artical)
        .then((response) => {
          if (response.data.status) {
            swal(" Updated Successfully", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
           getPaymentOptions()
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
       
        });
    }
  
  }
  return (
    <div className="row">
      <div className="col-xl-12 col-lg-12">
        <div
          className="card"
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
          <div className="card-header">
            <h4 className="card-title text-white">Payment Options</h4>
          </div>
          <div className="card-body">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <div className="basic-form row">
                {options &&
                  options.map((val) => {
                    return (
                      <>
                        <div className="col-sm-8 mt-3">{val.name}</div>
                        <div className="col-sm-4 mt-3">
                          <Switch
                            onColor="#135334"
                            onChange={() => {
                              changePaymentOption(val.name,val.status);
                            }}
                            checked={val.status}
                          />
                        </div>
                      </>
                    );
                  })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentOption;
